var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactCardId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#2837AA",
    fillOpacity: 0.1,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 9.5,
    x: 3.5,
    y: 5.25,
    stroke: "#7896D2",
    strokeWidth: 1.1,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7896D2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.6,
    cy: 8.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2 12.9c0-1.2 1.075-1.9 2.4-1.9s2.4.7 2.4 1.9H5.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.2,
    height: 1.1,
    x: 11.2,
    y: 8.3,
    rx: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1.1,
    x: 11.2,
    y: 10.8,
    rx: 0.55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCardId);
export default __webpack_public_path__ + "static/media/contactCardId.3268dbdca09290fae8d0d328bbb3fe8c.svg";
export { ForwardRef as ReactComponent };